<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" plain @click="exportDorm" v-if="!isMB">导出</el-button>
        <template v-if="$permission.canWrite()">
          <el-button size="mini" type="success" plain @click="importDorm" v-if="!isMB">导入</el-button>
          <el-button size="mini" type="primary" plain @click="openEmp">设置管理人员</el-button>
          <el-button size="mini" type="primary" @click="create" icon="el-icon-plus">添加</el-button>
          <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
        </template>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="60">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.DormitoryId)">编辑</el-button>
            <!-- <el-button type="text" @click="setDorm(row)">管理学生</el-button> -->
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <set-st-dialog ref="setStDialog" @close-saved="reload" />
    <import-dialog ref="importDialog" @upload-success="reload" />
    <emp-dialog ref="empDialog" in-dialog selectable multiple :show-other="false" @select-multiple="setEmps" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/lo/dorm/list";
import editDialog from "@/components/lo/dorm/editDialog";
import importDialog from "@/components/lo/dorm/importDialog";
import setStDialog from "@/components/lo/dorm/setStDialog";
import empDialog from "@/components/fa/teacher/listDialog";

export default {
  name: "dorm",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialog,
    empDialog,
    setStDialog
  },
  data() {
    return {
      dormIds: [],
      api: require("@/api/lo/dorm").default,
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    importDorm() {
      this.$refs.importDialog.open();
    },
    exportDorm() {
      this.$refs.list.export();
    },
    setDorm(row) {
      this.$refs.setStDialog.openEdit(row);
    },
    openEmp() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要设置的宿舍");
        return;
      }
      this.dormIds = rows.map((item) => {
        return item.DormitoryId;
      });
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmps(emps) {
      if(!emps.length) return;
      var TeacherIds = emps.map(x => x.TeacherId);
      this.api.setTeachers({
        TeacherIds,
        DormitoryIds: this.dormIds
      }).then(res => {
        if(res.Code == 0) {
          this.$message.success("设置成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      })
      // console.log(TeacherIds,this.dormIds);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DormitoryId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>